<template>
  <div>
    <Navbar/>
    <h4></h4>
<!-- Master -->
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2">
                  <label for="idMotivoCita" class="form-label">IdMotivoCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMotivoCita" name="idMotivoCita" v-model="datoMotivoCita.idMotivoCita" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="nombre" class="form-label">Nombre</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="nombre" name="nombre" v-model="datoMotivoCita.nombre" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <button type="submit" class="btn btn-light" @click.prevent="guardarMotivoCita" v-if="btnCrear" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditMotivoCita" v-if="btnEditar" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>

<!-- Details -->
    <hr>
      <div class="mb-3">
        <table class="tablaBusqueda">
          <tr>
            <td><label for="nombre" class="form-label">Nombre</label></td>
            <td><input type="text" class="form-control" id="nombreBusqueda" name="nombreBusqueda" v-model="nombreBusqueda" style="width: 500px; text-transform:uppercase;" required></td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPagina(1)" title="Buscar registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">search</i> Buscar
              </button>
            </td>
            <td class="centro">
              <button type="submit" class="btn btn-light" @click.prevent="getDataPaginaTodos(1)" title="Todos los registros">
                <i class="material-icons" style="font-size:24px;color:blue; cursor: pointer;">auto_awesome_motion</i>
              </button>
            </td>
            <td>
              <button type="submit" class="btn btn-light" data-bs-toggle="modal" data-bs-target="#ventanaModal" @click="abrirModalCrear" title="Nuevo registro">
                <i class="material-icons" style="font-size:24px;color:green; cursor: pointer;">add_box</i>
              </button>
            </td>
          </tr>
        </table>
      </div>
    <table class="table table-striped" id="sampleTable">
      <thead>
        <tr>
          <th scope="col"></th>
          <th scope="col"></th>
          <th scope="col">IdCita</th>
          <th scope="col">IdEmpresa</th>
          <th scope="col">IdPersona</th>
          <th scope="col">IdUsuarioReg</th>
          <th scope="col">IdUsuarioAct</th>
          <th scope="col">IdMedico</th>
          <th scope="col">IdEspecialidad</th>
          <th scope="col">IdAgenda</th>
          <th scope="col">FechaReg</th>
          <th scope="col">FechaAct</th>
          <th scope="col">FechaCita</th>
          <th scope="col">Hora Desde</th>
          <th scope="col">Hora Hasta</th>
          <th scope="col">EstadoCita</th>
          <th scope="col">Descripcion</th>
          <th scope="col">Observacion</th>
          <th scope="col">Estado</th>
          <th scope="col">AgendaObservacion</th>
          <th scope="col">EmpresaNombre</th>
          <th scope="col">EspecialidadNombre</th>
          <th scope="col">PersonaFechaReg</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="cita in datosPaginados" :key="cita.idCita">
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirModalEditar(cita.idCita)" title="Editar">edit_square</i></td>
          <td><i class="material-icons" style="font-size:16px;color:orangered; cursor: pointer;" @click="abrirEditar(cita.idCita)" title="Editar">edit_square</i></td>
          <td>{{cita.idCita}}</td>
          <td>{{cita.idEmpresa}}</td>
          <td>{{cita.idPersona}}</td>
          <td>{{cita.idUsuarioReg}}</td>
          <td>{{cita.idUsuarioAct}}</td>
          <td>{{cita.idMedico}}</td>
          <td>{{cita.idEspecialidad}}</td>
          <td>{{cita.idAgenda}}</td>
          <td>{{getFormattedDate(cita.fechaReg, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(cita.fechaAct, 'DD/MM/YYYY')}}</td>
          <td>{{getFormattedDate(cita.fechaCita, 'DD/MM/YYYY')}}</td>
          <td>{{cita.horaDesde}}</td>
          <td>{{cita.horaHasta}}</td>
          <td>{{cita.estadoCita}}</td>
          <td>{{cita.descripcion}}</td>
          <td>{{cita.observacion}}</td>
          <td>{{cita.estado}}</td>
          <td>{{cita.agendaObservacion}}</td>
          <td>{{cita.empresaNombre}}</td>
          <td>{{cita.especialidadNombre}}</td>
          <td>{{getFormattedDate(cita.personaFechaReg, 'DD/MM/YYYY')}}</td>
          <td><i class="material-icons" style="font-size:16px;color:red; cursor: pointer;" @click="deleteMotivoCita(cita.idCita)" title="Borrar">delete</i></td>
        </tr>
      </tbody>
    </table>
    <nav aria-label="Page navigation example">
      <ul class="pagination">
        <li class="page-item" v-on:click="getPreviousPage()"><a class="page-link" href="#">Anterior</a></li>
        <li id="lugar" v-for="pagina in totalPaginas()" v-bind:key="pagina" v-on:click = "getDataPagina(pagina)" class="page-item" v-bind:class="isActive(pagina)"><a class="page-link" href="#">{{pagina}}</a></li>
        <li class="page-item" v-on:click="getNextPage()"><a class="page-link" href="#">Siguiente</a></li>
      </ul>
    </nav>
<!-- Modal -->
<div class="modal fade" id="ventanaModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" v-if="modalWindow">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title" id="exampleModalLabel">
          <i class="fa fa-user-plus"></i> {{titulo}}</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
        </button>
      </div>
      <form>
        <div class="modal-body">
            <div class="mb-3" v-if="btnEditar_det">
              <div class="row">
                <div class="col-2">
                  <label for="idCita" class="form-label">IdCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idCita" name="idCita" v-model="datoCita.idCita" disabled>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEmpresa" class="form-label"> Empresa</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEmpresa" name="idEmpresa" v-model="datoCita.idEmpresa">
                      <option v-for="empresa in empresas" :value="empresa.idEmpresa" :key="empresa.idEmpresa">
                        {{ empresa.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idPersona" class="form-label"> Persona</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idPersona" name="idPersona" v-model="datoCita.idPersona">
                      <option v-for="persona in personas" :value="persona.idPersona" :key="persona.idPersona">
                        {{ persona.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioReg" class="form-label">IdUsuarioReg</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioReg" name="idUsuarioReg" v-model="datoCita.idUsuarioReg" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idUsuarioAct" class="form-label">IdUsuarioAct</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idUsuarioAct" name="idUsuarioAct" v-model="datoCita.idUsuarioAct" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idMedico" class="form-label"> Medico</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idMedico" name="idMedico" v-model="datoCita.idMedico">
                      <option v-for="medico in medicos" :value="medico.idMedico" :key="medico.idMedico">
                        {{ medico.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idEspecialidad" class="form-label"> Especialidad</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idEspecialidad" name="idEspecialidad" v-model="datoCita.idEspecialidad">
                      <option v-for="especialidad in especialidads" :value="especialidad.idEspecialidad" :key="especialidad.idEspecialidad">
                        {{ especialidad.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
<!-- Botón Lista de Valores -->
                <div class="row">
                  <div class="col-2">
                    <label for="idAgenda" class="form-label"> Agenda</label>
                  </div>
                  <div class="col-10">
                    <select class="form-control" id="idAgenda" name="idAgenda" v-model="datoCita.idAgenda">
                      <option v-for="agenda in agendas" :value="agenda.idAgenda" :key="agenda.idAgenda">
                        {{ agenda.nombre }}
                      </option>
                    </select>
                  </div>
                </div>
<!-- Botón Lista de Valores -->
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaReg" class="form-label">FechaReg</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaReg" name="fechaReg" v-model="datoCita.fechaReg" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaAct" class="form-label">FechaAct</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaAct" name="fechaAct" v-model="datoCita.fechaAct" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="fechaCita" class="form-label">FechaCita</label>
                </div>
                <div class="col-10">
                <input type="date" class="form-control" id="fechaCita" name="fechaCita" v-model="datoCita.fechaCita" required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaDesde" class="form-label">HoraDesde</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaDesde" name="horaDesde" v-model="datoCita.horaDesde" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="horaHasta" class="form-label">HoraHasta</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="horaHasta" name="horaHasta" v-model="datoCita.horaHasta" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="estadoCita" class="form-label">EstadoCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="estadoCita" name="estadoCita" v-model="datoCita.estadoCita" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="descripcion" class="form-label">Descripción</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="descripcion" name="descripcion" v-model="datoCita.descripcion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="observacion" class="form-label">Observación</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="observacion" name="observacion" v-model="datoCita.observacion" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
            <div class="mb-3">
              <div class="row">
                <div class="col-2">
                  <label for="idMotivoCita" class="form-label">IdMotivoCita</label>
                </div>
                <div class="col-10">
                <input type="text" class="form-control" id="idMotivoCita" name="idMotivoCita" v-model="datoCita.idMotivoCita" style='text-transform:uppercase' required>
                </div>
              </div>
            </div>
          </div>
      </form>
      <div class="modal-footer">
        <div class="me-auto">
          <button type="button" id="send" class="btn btn-light" data-bs-dismiss="modal" title="Cerrar">
            <i class="material-icons" style="font-size:32px;color:orangered; cursor: pointer;">meeting_room</i>
          </button>
        </div>
        <button type="submit" class="btn btn-light" @click.prevent="guardarCita" v-if="btnCrear_det" title="Guardar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">save</i>
        </button>
        <button type="submit" class="btn btn-light" @click.prevent="guardarEditCita" v-if="btnEditar_det" title="Actualizar">
          <i class="material-icons" style="font-size:32px;color:blue; cursor: pointer;">update</i>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Details -->

    <Footer/>
  </div>
</template>
<script>
import Navbar from '../../components/Navbar.vue'
import Footer from '../../components/Footer.vue'
import { validarForm } from '../../modules/validacionesForms.js';
import api from "@/services/api";
import * as $ from 'jquery';
window["$"] = $;
window["jQuery"] = $;
import swal from  'sweetalert'
export default {
  components : {
    Navbar, Footer
  },
  data () {
    return {
// Variables master
      motivocitas : [],
      datoMotivoCita : {},
      nombreBusqueda: '',
      titulo: '',
      btnCrear: false,
      btnEditar: false,
      p_idMotivoCita: '',
// Variables master
// Variables details
      citas : [],
      datoCita : {},
      nombreBusqueda_det: '',
      titulo_det: '',
      btnCrear_det: false,
      btnEditar_det: false,
      elementosPorPagina: 10,
      datosPaginados: [],
      paginaActual: 1,
      personas : [],
      medicos : [],
      especialidads : [],
      agendas : [],
      motivoCitas : [],
      modalWindow: true
// Variables details
    }
  },
  mounted () {
    this.p_idMotivoCita = this.$route.params.p_idmotivocita
    this.abrirEditar(this.p_idMotivoCita)
    this.getDataPagina(this.paginaActual)
  },
  methods : {
// Procedimientos master
    validarForm(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoMotivoCita, requiredFields, requiredFieldsText);
    },
    async guardarMotivoCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/motivocitas', this.datoMotivoCita)
          swal("Correcto!", "MotivoCita creada exitosamente!", "success");
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditMotivoCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/motivocitas', this.datoMotivoCita)
          swal("Correcto!", "MotivoCita creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirCrear(){
      this.modalWindow = true
      this.datoMotivoCita={}
      this.titulo   = 'Crear '
      this.btnCrear = true
      this.btnEditar= false
    },
    abrirEditar(idMotivoCita){
      this.modalWindow = true
      if(idMotivoCita != null){    
           api.get('/vwmotivocitas/'+idMotivoCita).then(resp=>{
          this.datoMotivoCita = resp.data;
           });
      }
      this.titulo   = 'Editar '
      this.btnCrear = false
      this.btnEditar= true
    },
    cerrarMotivoCita(){
      this.$router.push('/MotivoCita')
    },
// Procedimientos master
// Procedimientos detalle
    totalPaginas(){
      return Math.ceil(this.citas.length / this.elementosPorPagina)
    },
    getDataPagina(noPagina){
      if(this.nombreBusqueda != '') {
        api.get('/vwcitas/nombre/'+this.nombreBusqueda).then(response=>{
          this.citas=response.data.reverse();  
          this.paginaActual = noPagina;
          this.datosPaginados = [];
          let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
          let fin = (noPagina * this.elementosPorPagina);
          this.datosPaginados = this.citas.slice(ini,fin);
        });
      }
    },
    getDataPaginaTodos(noPagina){
      api.get('/vwcitas').then(response=>{
      this.citas=response.data.reverse();  
      this.paginaActual = noPagina;
      this.datosPaginados = [];
      let ini = (noPagina * this.elementosPorPagina) - this.elementosPorPagina;
      let fin = (noPagina * this.elementosPorPagina);
      this.datosPaginados = this.citas.slice(ini,fin);
       });
    },
    getPreviousPage(){
      if(this.paginaActual > 1){
        this.paginaActual--;
      }
      this.getDataPagina(this.paginaActual);
    },
    getNextPage(){
      if(this.paginaActual < this.totalPaginas()){
        this.paginaActual++;
      }
      this.getDataPagina(this.paginaActual);
    },
    isActive(noPagina){
      return noPagina == this.paginaActual ? 'active' : ''
    },
    validarFormDet(){
      const requiredFields = [
        'nombre'
      ];
      const requiredFieldsText = [
        'nombre'
      ];
      return validarForm(this.datoMotivoCita, requiredFields, requiredFieldsText);
    },
    async guardarCita(){
      if(this.validarForm() === 1){
        try {
          this.datoCita.idMotivoCita = this.datoMotivoCita.idMotivoCita;
          await api.post('/citas', this.datoCita)
          $('#ventanaModal').modal('hide');
          swal("Correcto!", "Cita creada exitosamente!", "success");
          this.getDataPagina(this.paginaActual);
        } catch (error) { 
          swal("Error!", "Intentelo de nuevo!", "error");
        }
      }
    },
    async guardarEditCita(){
      if(this.validarForm() === 1){
        try {
          await api.post('/citas', this.datoCita)
          $('#ventanaModal').modal('hide');
          this.getDataPagina(this.paginaActual);
          swal("Correcto!", "Cita creado(a) exitosamente!", "success");
        } catch (error) {
          swal("Error!", "Intentelo de nuevo!", "error");
          var array = Object.values(error.response.data.errors)
          array.forEach(element => swal(String(element)))
        }
      }
    },
    abrirModalCrear(){
      this.modalWindow = true
      this.datoCita={}
      this.titulo   = 'Crear '
      this.btnCrear_det  = true
      this.btnEditar_det = false
    },
    abrirModalEditar(idCita){
      this.modalWindow = true
      if(idCita != null){    
           api.get('/vwcitas/'+idCita).then(resp=>{
          this.datoCita = resp.data;
           });
      }
      $('#ventanaModal').modal('show');
      this.titulo   = 'Editar '
      this.btnCrear_det  = false
      this.btnEditar_det = true
    },
    abrirEditarDet(idCita){
      this.modalWindow = true
      if(idCita != null){
        this.$router.push('/citamd/'+idCita)
      }
    },
    async deleteCita (idCita) {
      try{
        await api.delete('/citas/'+idCita)
          this.getDataPagina(this.paginaActual);
      }catch(error){
        alert('No se pudo eliminar')
      }
    },
// Procedimientos detalle
    fetchPersonas() {
      fetch('http://localhost:8080/api/v1/personas')
        .then(response => response.json())
        .then(data => {
          this.personas = data;
        })
        .catch(error => {
          console.error('Error fetching personas:', error);
        });
    },
    fetchMedicos() {
      fetch('http://localhost:8080/api/v1/medicos')
        .then(response => response.json())
        .then(data => {
          this.medicos = data;
        })
        .catch(error => {
          console.error('Error fetching medicos:', error);
        });
    },
    fetchEspecialidads() {
      fetch('http://localhost:8080/api/v1/especialidads')
        .then(response => response.json())
        .then(data => {
          this.especialidads = data;
        })
        .catch(error => {
          console.error('Error fetching especialidads:', error);
        });
    },
    fetchAgendas() {
      fetch('http://localhost:8080/api/v1/agendas')
        .then(response => response.json())
        .then(data => {
          this.agendas = data;
        })
        .catch(error => {
          console.error('Error fetching agendas:', error);
        });
    },
    fetchMotivoCitas() {
      fetch('http://localhost:8080/api/v1/motivocitas')
        .then(response => response.json())
        .then(data => {
          this.motivoCitas = data;
        })
        .catch(error => {
          console.error('Error fetching motivoCitas:', error);
        });
    },
  },
}
</script>
